import React, { PureComponent } from 'react';
import Proptypes from 'prop-types';
import { translate } from 'react-i18next';

import { Form } from 'common/components';
import AssetsFormNotesRow from 'components/assets/form_sections/AssetsFormNotesRow';
import AssetsFormNotesRowNew from 'components/assets/form_sections/AssetsFormNotesRowNew';

class AssetsFormNotes extends PureComponent {
  static propTypes = {
    asset: Proptypes.shape({ _notes: Proptypes.array.isRequired }).isRequired,
    handleAddNote: Proptypes.func.isRequired,
    handleRemoveNote: Proptypes.func.isRequired,
    handleModifyNote: Proptypes.func.isRequired,
    user: Proptypes.shape({
      name: Proptypes.string.isRequired,
      lastname: Proptypes.string.isRequired,
      email: Proptypes.string.isRequired,
    }).isRequired,
    t: Proptypes.func.isRequired,
  };

  handleAddNote = (e) => {
    e && e.preventDefault();
    this.props.handleAddNote(this.props.user);
  };

  renderNotes = () => {
    const notes =
      (this.props.asset._notes && this.props.asset._notes.filter((note) => !note.deleted)) || [];

    return (
      (notes.length &&
        notes.map((note) =>
          note.createdAt ? (
            <AssetsFormNotesRow
              key={note.id}
              id={note.id}
              note={note}
              handleRemove={this.props.handleRemoveNote}
            />
          ) : (
            <AssetsFormNotesRowNew
              key={note.id}
              id={note.id}
              note={note}
              handleModify={this.props.handleModifyNote}
              handleRemove={this.props.handleRemoveNote}
            />
          )
        )) || (
        <tr>
          <td colSpan="4">
            <div className="alert alert-info text-center mb-0">
              <i className="fa fa-lg fa-info-circle pr-3" />
              {this.props.t('assets.fields.notes.empty')}
            </div>
          </td>
        </tr>
      )
    );
  };

  render = () => (
    <div className="row mt-3 align-items-center bbottom">
      <div className="col-sm-12">
        <h5>
          <b>{this.props.t('assets.section.notes')}</b>
          <Form.Button
            onClick={this.handleAddNote}
            className="btn btn-primary btn-sm pull-right"
            text={this.props.t('actions.add')}
          />
        </h5>
        <br />
      </div>
      <div className="col-sm-12 mb-3">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th width="50%">{this.props.t('assets.fields.notes.text')}</th>
              <th width="20%">{this.props.t('assets.fields.notes.createdAt')}</th>
              <th width="20%">{this.props.t('assets.fields.notes.createdBy')}</th>
              <th width="10%" className="text-center">
                {this.props.t('common.actions')}
              </th>
            </tr>
          </thead>
          <tbody>{this.renderNotes()}</tbody>
        </table>
      </div>
    </div>
  );
}

export default translate()(AssetsFormNotes);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormNotes.js